// extracted by mini-css-extract-plugin
export var background = "hello-module--background--g7_pw";
export var component = "hello-module--component--3A8Z4";
export var container = "hello-module--container--1kkOw";
export var tagline = "hello-module--tagline--2opwz";
export var buttons = "hello-module--buttons--R4ntd";
export var button = "hello-module--button--Dj7JW";
export var logo = "hello-module--logo--2QQhr";
export var icon = "hello-module--icon--31cOv";